import { useEffect } from 'react';
import { createApolloClient } from '../graphql';
import type { NextPage } from 'next';
import { GET_SERVICEABLE_COUNTRIES } from 'src/http/country';
import HomePage from '../containers/HomePage';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { AppRoutes } from '@utils/appRoutes';
import useAuth from '@utils/useAuth';
import PageLoader from '@components/PageLoader';
import { countryList } from '@utils/constant/countryList';

const Home: NextPage = () => {
  const router = useRouter();
  const { detectedCountryCode } = useAuth();

  useEffect(() => {
    //router.prefetch('/order/step-1');
    if (detectedCountryCode) {
      const isServicableCountry = countryList.find(
        (country) => country.value === detectedCountryCode?.toLowerCase()
      );
      let countryCode = isServicableCountry ? isServicableCountry.value : 'usa';

      // Carry the FULL query string through the redirect. Forwarding only
      // `promo` silently dropped every other param — utm_*, and the
      // home-redesign test's hv/vid, whose loss made control-arm conversions
      // untrackable (they arrive here via the homepage's bare-root CTAs).
      router.push(
        `/${countryCode}${AppRoutes.ORDER_STEP_TWO}${window.location.search}`
      );
    }
  }, [detectedCountryCode]);

  return <PageLoader />;

  // Comment added for deplo

  // return (
  //   <>
  //     <Head>
  //       <title>
  //         Authentic Indian Food Meal Kits Delivered | The Cumin Club | $4.99 Per
  //         Meal
  //       </title>
  //     </Head>
  //     <HomePage />
  //   </>
  // );
};

// This gets called on every request
// export async function getStaticProps() {
//   const apolloClient = createApolloClient();
//   const fetchServiceableCountries = async () => {
//     try {
//       const res = await apolloClient.query({
//         query: GET_SERVICEABLE_COUNTRIES,
//       });
//       return res;
//     } catch (error) {
//       console.log(error);
//       return { error };
//     }
//   };
//   await fetchServiceableCountries();
//   return { props: { initialApolloState: apolloClient.cache.extract() } };
// }

export default Home;
